<template>
  <div class="dialogue_form_admin" v-if="userForm.form && userForm.form.length" :class="{
    hiden_close:!isShowClose
  }">
    <!-- header -->
    <div class="header">
        <div style="font-weight: 700;display: flex;align-items: center;">
          <img :src="dialogue_form_icon" class="form_img" />
          <div>对话设置</div>
        </div>
        <a-icon v-if="isShowClose" type="close" style="font-size: 16px;cursor: pointer;" @click="onClose" />
    </div>
    <!-- content -->
    <div class="content">
        <a-form-model ref="form" :model="form" :rules="rules">
            <a-form-model-item :label="item.label" :prop="item.variable" v-for="(item,index) in userForm.form" :key="index">
                
                <a-select v-model="form[item.variable]" v-if="item.fieldType=='select'" :placeholder="item.default" @change="onChange">
                    <a-select-option :value="x" v-for="(x,i) in item.options" :key="i">{{x}}</a-select-option>
                </a-select>

                <a-input @change="onChange" v-model="form[item.variable]" v-if="item.fieldType=='text-input' || item.fieldType=='textInput'" :placeholder="item.default" :maxLength="item.max_length || item.maxLength" />

                <a-textarea
                    v-model="form[item.variable]"
                    v-if="item.fieldType=='paragraph'" 
                    :placeholder="item.default" 
                    :maxLength="item.max_length || item.maxLength"
                    :auto-size="{ minRows: 3, maxRows: 5 }"
                    @change="onChange"
                />
                
                <a-input-number 
                    style="width:100%;" 
                    v-model="form[item.variable]"
                    :placeholder="item.default" 
                    v-if="item.fieldType=='number'" 
                    @change="onChange"
                />
            </a-form-model-item>
            
            <!-- <formUpload></formUpload>-->
            <!-- <a-form-model-item>
                <a-button type="primary" style="width:100%;margin-top:16px;background: rgb(26,94,240);" @click="onSubmit">提交设置</a-button>
            </a-form-model-item>  -->
        </a-form-model>
    </div>
  </div>
</template>

<script>
import formUpload from '@/components/upload/formUpload.vue'
import dialogue_form_icon from '@/assets/dialogue_form_icon.png'
import { mapGetters,mapMutations } from 'vuex'

export default {
    components:{
        formUpload
    },
    computed:{
        ...mapGetters('aiConfig',{
            userForm:'userForm'
        })
    },
    watch:{
        userForm:{
            handler(val) {
                this.form = _.cloneDeep(val.formParmas)
                this.rules = _.cloneDeep(val.rules)
                if(val.defaultFormData){
                    this.form = _.cloneDeep(val.defaultFormData)
                }
            },
            deep: true,
            immediate: true
        },
    },
    props:{
        visible:{
            type: Boolean,
            default: false
        },
        isShowClose:{
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
          dialogue_form_icon,
            form: {},
            rules: {}
        }
    },
    methods: {
        ...mapMutations('aiConfig',['setFormData']),
        onChange(){
            this.setFormData(this.form)
        },
        onSubmit(){
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    this.setFormData(this.form)
                    this.onClose()
                }
            });
        },
        onClose(){
            this.$emit('update:visible',false)
        }
    }
}
</script>

<style lang="scss" scoped>
.form_img{
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.dialogue_form_admin{
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #ebeef5;
    ::v-deep .ant-input{
        background: #F0F3F8 !important;
        border-radius: 4px !important;
        border: none !important;
    }
    ::v-deep .ant-input:focus{
        box-shadow:none !important;
    }
    ::v-deep .ant-select-selection{
        background: #F0F3F8 !important;
        border-radius: 4px !important;
        border: none !important;
    }
    ::v-deep .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active{
        box-shadow:none !important;
    }
    ::v-deep .ant-input-number{
        background: #F0F3F8 !important;
        border-radius: 4px !important;
        border: none !important;
    }
    ::v-deep .ant-input-number-focused{
        box-shadow:none !important;
    }
    ::v-deep .ant-form-item{
        margin-bottom: 0 !important;
    }

    .content{
        padding: 14px 24px;
    }
    .header{
        display: flex;
        justify-content: space-between;
        padding: 16px 24px;
        font-weight: 500;
        font-size: 16px;
        color: rgba(0,0,0,0.85);
        line-height: 24px;
        border-bottom: 1px solid rgba(0,0,0,0.06);
    }
}
</style>